export default {"src":"/_next/static/media/front-yard.0440e10c.svg","height":29,"width":26,"blurWidth":0,"blurHeight":0};